import { render } from "./CollabTypes.vue?vue&type=template&id=11a3cfb6&scoped=true"
import script from "./CollabTypes.vue?vue&type=script&lang=js"
export * from "./CollabTypes.vue?vue&type=script&lang=js"

import "./CollabTypes.vue?vue&type=style&index=0&id=11a3cfb6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a3cfb6"]])

export default __exports__